module.exports = __webpack_public_path__ + "fonts/pizzagame.f9c3cd43.woff";